import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import {linkComponentDecorator} from 'blocks/LinkRenderComponent'

class ProviderMainInfo extends React.Component{
  htmlToDrafJs = html => {
    const {contentBlocks, entityMap} = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    return EditorState.createWithContent(contentState);
  };
  render(){
    const provider = this.props.provider;
    return(
      <div className="main-info col-12 col-md-6">
        <div className="name-block">
          <div className="fullname">
            {provider.name}
          </div>
        </div>
        <div className="bio">
          <h4 className="title">Provider bio</h4>
          <Editor
            customDecorators={[linkComponentDecorator]}
            editorState={this.htmlToDrafJs(provider.bio || '')}
            toolbarClassName="nonDispayed"
            wrapperClassName="noneBorder"
            editorClassName="noneBorder"
            placeholder="Description editor…"
            options={null}
            readOnly={true}
          />
        </div>
        <div className="qualifications">
          <h4 className="title">Qualifications/Experience</h4>
          <Editor
            customDecorators={[linkComponentDecorator]}
            editorState={this.htmlToDrafJs(provider.qualifications || '')}
            toolbarClassName="nonDispayed desc"
            wrapperClassName="noneBorder"
            editorClassName="noneBorder"
            placeholder="Description editor…"
            options={null}
            readOnly={true}
          />
        </div>
      </div>
    )
  }

}

export default ProviderMainInfo



// WEBPACK FOOTER //
// ./src/components/provider/ProviderMainInfo.jsx